(function () {

    'use strict';

    angular.module('Services')
        .factory('FleetService', function ($http, $rootScope, Error, Request, $filter) {
            return {
                multiSearch: function (successCallback, errorCallback, data) {
                    Request.get({
                        url: ApiURLs.fleets.multiSearch,
                        successCallback,
                        errorCallback,
                        data
                    });
                },
                Fleets: {
                    getAll: function (callback, errCallback, data) {
                        Request.get({
                            url: ApiURLs.fleets.fleets,
                            successCallback: callback,
                            errorCallback: errCallback,
                            data: data
                        });
                    },
                    get: function (id, callback, errCallback) {
                        Request.get({
                            url: ApiURLs.fleets.fleetDetails + id,
                            successCallback: callback,
                            errorCallback: errCallback
                        });
                    },
                    getFleetVehicles: function (callback, errCallback, data) {
                        Request.get({
                            url: ApiURLs.fleets.vehicles,
                            successCallback: callback,
                            errorCallback: errCallback,
                            data: data
                        });
                    },
                    create: function (payload, callback, errCallback) {
                        Request.post({
                            url: ApiURLs.fleets.fleets,
                            method: 'POST',
                            successCallback: callback,
                            errorCallback: errCallback
                        }, payload);
                    },
                    delete: function (id, callback, errCallback) {
                        Request.delete({
                            url: ApiURLs.fleets.fleets + id,
                            successCallback: callback,
                            errorCallback: errCallback
                        });
                    },
                    update: function (id, payload, callback, errCallback) {
                        Request.post({
                            url: ApiURLs.fleets.fleetDetails + id,
                            method: 'PUT',
                            successCallback: callback,
                            errorCallback: errCallback
                        }, payload);
                    },
                    jobsExports: function (columns, requestData, callback, errCallback) {
                        var cols = {};
                        if (columns !== undefined && columns.length > 0) {
                            cols = { columns: columns };
                        }

                        Request.exportFile({
                            method: 'GET',
                            fileName: 'jobs-export.csv',
                            url: ApiURLs.fleets.jobExport,
                            data: cols,
                            fileType: 'text/csv',
                            successCallback: callback,
                            errorCallback: errCallback,
                            responseType: 'arraybuffer',
                            contentType: 'application/json'
                        }, requestData);
                    }

                },
                VehicleTypes: {
                    getAll: function (callback, errCallback, data) {
                        Request.get({
                            url: ApiURLs.fleets.vehicleTypes,
                            successCallback: callback,
                            errorCallback: errCallback,
                            data: data
                        });
                    },
                    get: function (id, callback, errCallback) {
                        Request.get({
                            url: ApiURLs.fleets.vehicleTypeDetails + id,
                            successCallback: callback,
                            errorCallback: errCallback
                        });
                    },
                    create: function (payload, callback, errCallback) {
                        Request.post({
                            url: ApiURLs.fleets.vehicleTypeDetails,
                            method: 'POST',
                            successCallback: callback,
                            errorCallback: errCallback
                        }, payload);
                    },
                    delete: function (id, callback, errCallback) {
                        Request.delete({
                            url: ApiURLs.fleets.vehicleTypeDetails + id,
                            successCallback: callback,
                            errorCallback: errCallback
                        });
                    },
                    update: function (id, payload, callback, errCallback) {
                        Request.post({
                            url: ApiURLs.fleets.vehicleTypeDetails + id,
                            method: 'PUT',
                            successCallback: callback,
                            errorCallback: errCallback
                        }, payload);
                    }
                },
                Vehicles: {
                    getAll: function (callback, errCallback, data) {
                        Request.get({
                            url: ApiURLs.fleets.vehicles,
                            successCallback: callback,
                            errorCallback: errCallback,
                            data: data
                        });
                    },
                    get: function (id, callback, errCallback) {
                        Request.get({
                            url: ApiURLs.fleets.vehicleDetails + id,
                            successCallback: callback,
                            errorCallback: errCallback
                        });
                    },
                    create: function (payload, callback, errCallback) {
                        Request.post({
                            url: ApiURLs.fleets.vehicleDetails,
                            method: 'POST',
                            successCallback: callback,
                            errorCallback: errCallback
                        }, payload);
                    },
                    update: function (id, payload, callback, errCallback) {
                        Request.post({
                            url: ApiURLs.fleets.vehicleDetails + id,
                            method: 'PUT',
                            successCallback: callback,
                            errorCallback: errCallback
                        }, payload);
                    },
                    delete: function (id, callback, errCallback) {
                        Request.delete({
                            url: ApiURLs.fleets.vehicleDetails + id,
                            successCallback: callback,
                            errorCallback: errCallback
                        });
                    },
                    upload: function (file, callback, errCallback, isVehiclePhoto) {
                        Request.upload({
                            url: ApiURLs.fleets.vehicleDetails + 'upload-photo',
                            method: 'POST',
                            successCallback: callback,
                            errorCallback: errCallback,
                            fileKey: 'photo',
                            data: isVehiclePhoto,
                            headers: {
                                'Accept': 'plain/text'
                            }
                        }, file);
                    }
                },
                DriverGroups: {
                    getAll: function (callback, errCallback, data) {
                        Request.get({
                            url: ApiURLs.fleets.driverGroups,
                            successCallback: callback,
                            errorCallback: errCallback,
                            data: data
                        });
                    },
                    get: function (id, callback, errCallback) {
                        Request.get({
                            url: ApiURLs.fleets.driverGroupDetails + id,
                            successCallback: callback,
                            errorCallback: errCallback
                        });
                    },
                    create: function (payload, callback, errCallback) {
                        Request.post({
                            url: ApiURLs.fleets.driverGroupDetails,
                            method: 'POST',
                            successCallback: callback,
                            errorCallback: errCallback
                        }, payload);
                    },
                    delete: function (id, callback, errCallback) {
                        Request.delete({
                            url: ApiURLs.fleets.driverGroupDetails + id,
                            successCallback: callback,
                            errorCallback: errCallback
                        });
                    },
                    update: function (id, payload, callback, errCallback) {
                        Request.post({
                            url: ApiURLs.fleets.driverGroupDetails + id,
                            method: 'PUT',
                            successCallback: callback,
                            errorCallback: errCallback
                        }, payload);
                    }
                },
                Drivers: {
                    getAll: function (callback, errCallback, data) {
                        Request.get({
                            url: ApiURLs.fleets.drivers,
                            successCallback: callback,
                            errorCallback: errCallback,
                            data: data
                        });
                    },
                    get: function (id, callback, errCallback) {
                        Request.get({
                            url: ApiURLs.fleets.driverDetails + id,
                            successCallback: callback,
                            errorCallback: errCallback
                        });
                    },
                    create: function (payload, callback, errCallback) {
                        Request.post({
                            url: ApiURLs.fleets.driverDetails,
                            method: 'POST',
                            successCallback: callback,
                            errorCallback: errCallback
                        }, payload);
                    },
                    update: function (id, payload, callback, errCallback) {
                        Request.post({
                            url: ApiURLs.fleets.driverDetails + id,
                            method: 'PUT',
                            successCallback: callback,
                            errorCallback: errCallback
                        }, payload);
                    },
                    delete: function (id, callback, errCallback) {
                        Request.delete({
                            url: ApiURLs.fleets.driverDetails + id,
                            successCallback: callback,
                            errorCallback: errCallback
                        });
                    },
                    upload: function (file, callback, errCallback, isDriverPhoto) {
                        Request.upload({
                            url: ApiURLs.fleets.driverDetails + 'upload-photo',
                            method: 'POST',
                            successCallback: callback,
                            errorCallback: errCallback,
                            fileKey: 'photo',
                            data: isDriverPhoto,
                            headers: {
                                'Accept': 'plain/text'
                            }
                        }, file);
                    },
                    getNearDrivers: function (payload, callback, errCallback, filter) {
                        Request.post({
                            url: ApiURLs.fleets.driverDetails,
                            method: 'POST',
                            successCallback: callback,
                            errorCallback: errCallback,
                            data: filter
                        }, payload);
                    }
                },
                Routes: {
                    getRoutes: function (callback, errCallback, data) {
                        Request.get({
                            url: ApiURLs.fleets.routes,
                            successCallback: callback,
                            errorCallback: errCallback,
                            data: data
                        });
                    },
                    getRoute: function (id, callback, errCallback) {
                        Request.get({
                            //url: `${ApiURLs.fleets.routes}/${id}`,
                            url: ApiURLs.fleets.routes + id,
                            successCallback: callback,
                            errorCallback: errCallback
                        });
                    },
                    getMapRoute: function (callback, errCallback, filter) {
                        Request.get({
                            //url: `${ApiURLs.fleets.routes}/${id}`,
                            url: ApiURLs.fleets.routes + 'my-route',
                            successCallback: callback,
                            errorCallback: errCallback,
                            data: filter
                        });
                    },
                    createRoute: function (payload, callback, errCallback) {
                        Request.post({
                            url: ApiURLs.fleets.routes,
                            method: 'POST',
                            successCallback: callback,
                            errorCallback: errCallback
                        }, payload);
                    },
                    updateRoute: function (id, payload, callback, errCallback) {
                        Request.post({
                            url: ApiURLs.fleets.routes + id,
                            method: 'PUT',
                            successCallback: callback,
                            errorCallback: errCallback
                        }, payload);
                    },
                    deleteRoute: function (id, callback, errCallback) {
                        Request.delete({
                            url: ApiURLs.fleets.routes + id,
                            successCallback: callback,
                            errorCallback: errCallback
                        });
                    },
                    getWaypoints: function (id, callback, errCallback, data) {
                        Request.get({
                            //url: `${ApiURLs.fleets.waypoints}/${id}`, //remove when API is available
                            url: ApiURLs.fleets.routeWaypoints + id,
                            successCallback: callback,
                            errorCallback: errCallback,
                            data: data
                        });
                    },
                    getJobs: function (callback, errCallback, data) {
                        Request.get({
                            //url: `${ApiURLs.fleets.waypoints}/${id}`, //remove when API is available
                            url: ApiURLs.fleets.jobs,
                            successCallback: callback,
                            errorCallback: errCallback,
                            data: data
                        });
                    }
                },
                Jobs: {
                    moveToArchives: function (jobIds, callback, errCallback) {
                        Request.post({
                            url: ApiURLs.fleets.jobs + 'archive',
                            method: 'POST',
                            successCallback: callback,
                            errorCallback: errCallback
                        }, jobIds);
                    },
                    moveToArchiveJobBatch: function (batchId, callback, errCallback) {
                        Request.post({
                            url: ApiURLs.fleets.jobs + 'archive/batch',
                            method: 'POST',
                            successCallback: callback,
                            errorCallback: errCallback
                        }, batchId);
                    },
                    jobsMapData: function (callback, errCallback, filters) {
                        Request.get({
                            url: ApiURLs.jobs.jobsMapData,
                            successCallback: callback,
                            errorCallback: errCallback,
                            data: filters
                        });
                    },
                    jobLists: function (id, callback, errCallback) {
                        Request.get({
                            url: ApiURLs.jobs.jobsListData,
                            successCallback: callback,
                            errorCallback: errCallback
                        });
                    },
                    getAll: function (callback, errCallback, data) {
                        Request.get({
                            url: ApiURLs.fleets.jobs,
                            successCallback: callback,
                            errorCallback: errCallback,
                            data
                        });
                    },
                    getJobDetails: function (id, callback, errCallback) {
                        Request.get({
                            url: ApiURLs.fleets.jobs + id,
                            successCallback: callback,
                            errorCallback: errCallback
                        });
                    },
                    getJobPackages: function (callback, errCallback) {
                        Request.get({
                            url: ApiURLs.jobs.getpPackages,
                            successCallback: callback,
                            errorCallback: errCallback
                        });
                    },
                    update: function (id, payload, callback, errCallback) {
                        Request.post({
                            url: ApiURLs.fleets.jobs + id,
                            method: 'PUT',
                            successCallback: callback,
                            errorCallback: errCallback
                        }, payload);
                    },
                    getAllJobBatches: function (callback, errCallback, data) {
                        Request.get({
                            url: ApiURLs.jobs.jobBatches,
                            successCallback: callback,
                            errorCallback: errCallback,
                            data
                        });
                    },
                    updateStatus: function (ids, opts, successCallback, errorCallback) {
                        Request.post({
                            url: ApiURLs.fleets.updateJobStatus + opts.toStatus.toUpperCase(),
                            method: 'PUT',
                            successCallback,
                            errorCallback
                        }, angular.extend({
                            ids,
                            remarks: opts.remarks,
                            jobIds: opts.jobIds || []
                        }));
                    },
                    getJobCostFormatted: function (jobData) {
                        return {
                            shipmentRate: jobData.jobFinancials.actualRateUpdated || !jobData.timeBased ?
                                $filter('bbaCurrency')(+jobData.jobFinancials.shipmentRate) : `${$filter('bbaCurrency')(+jobData.jobFinancials.minAmount)} - ${$filter('bbaCurrency')(+jobData.jobFinancials.maxAmount)}`,
                            tax: jobData.jobFinancials.actualRateUpdated || !jobData.timeBased ?
                                $filter('bbaCurrency')(+jobData.jobFinancials.taxes) : 'Tax depends on the final amount',
                            duties: jobData.jobFinancials.actualRateUpdated || !jobData.timeBased ?
                                $filter('bbaCurrency')(+jobData.jobFinancials.duties) : 'Duties depends on the final amount',
                            costPrice: jobData.jobFinancials.actualRateUpdated || !jobData.timeBased ?
                                $filter('bbaCurrency')(+jobData.jobFinancials.totalCostPrice) : `${$filter('bbaCurrency')(+jobData.jobFinancials.minAmount)} - ${$filter('bbaCurrency')(+jobData.jobFinancials.maxAmount)} plus tax and driver commission`
                        };
                    },
                    // TODO: need to fix this one
                    getJobCostFormattedForFinalAndQuotedPricing(data, displayFinalPrice = false) {
                        return {
                            shipmentRate: displayFinalPrice || !data.timeBased ?
                                $filter('bbaCurrency')(+data.shipmentRate) : `${$filter('bbaCurrency')(+data.minAmount)} - ${$filter('bbaCurrency')(+data.maxAmount)}`,
                            tax: displayFinalPrice || !data.timeBased ?
                                $filter('bbaCurrency')(+data.taxes) : 'Tax depends on the final amount',
                            duties: displayFinalPrice || !data.timeBased ?
                                $filter('bbaCurrency')(+data.duties) : 'Duties depends on the final amount',
                            costPrice: displayFinalPrice || !data.timeBased ?
                                $filter('bbaCurrency')(+data.totalCostPrice) : `${$filter('bbaCurrency')(+data.minAmount)} - ${$filter('bbaCurrency')(+data.maxAmount)} plus tax and driver commission`
                        }
                    },
                    assign: function (ids, driverId, successCallback, errorCallback) {
                        Request.post({
                            url: ApiURLs.jobs.assign.replace(':driverId', driverId),
                            method: 'POST',
                            successCallback,
                            errorCallback
                        }, ids);
                    },
                    jobTracking: function (id, successCallback, errorCallback) {
                        Request.get({
                            url: ApiURLs.jobs.jobTracking.replace(':jobId', id),
                            successCallback: successCallback,
                            errorCallback: errorCallback
                        });
                    },
                    uploadPod: function (payload, successCallback, errorCallback) {
                        $http.post(`${ApiURLs.jobs.uploadPod}?jobId=${payload.query.jobId}&reseller_id=${payload.query.resellerId}&name=${payload.query.name}&remarks=${payload.query.remarks}`, payload.frmData, {
                            transformRequest: angular.identity,
                            headers: {
                                'Content-Type': undefined
                            }
                        }).then(response => {
                            successCallback(response);
                        }).catch(error => {
                            errorCallback(error);
                        });
                    },
                    assingPriority: function (payload, successCallback, errorCallback) {
                        // todo: implement API here
                        errorCallback({ message: "Api not implemented" });
                    }
                },
                Areas: {
                    getAll: function (callback, errCallback, data) {
                        Request.get({
                            url: ApiURLs.fleets.areas,
                            successCallback: callback,
                            errorCallback: errCallback,
                            data: data
                        });
                    },
                    get: function (id, callback, errCallback) {
                        Request.get({
                            url: ApiURLs.fleets.areas + id,
                            successCallback: callback,
                            errorCallback: errCallback
                        });
                    },
                    create: function (payload, callback, errCallback) {
                        Request.post({
                            url: ApiURLs.fleets.areas,
                            method: 'POST',
                            successCallback: callback,
                            errorCallback: errCallback
                        }, payload);
                    },
                    update: function (id, payload, callback, errCallback) {
                        Request.post({
                            url: ApiURLs.fleets.areas + id,
                            method: 'PUT',
                            successCallback: callback,
                            errorCallback: errCallback
                        }, payload);
                    },
                    delete: function (id, callback, errCallback) {
                        Request.delete({
                            url: ApiURLs.fleets.areas + id,
                            successCallback: callback,
                            errorCallback: errCallback
                        });
                    },
                    getAreaJobs: function (id, callback, errCallback, filters) {
                        Request.get({
                            url: ApiURLs.fleets.jobs + 'area/' + id,
                            successCallback: callback,
                            errorCallback: errCallback,
                            data: filters
                        });
                    }
                },
                Waypoints: {
                    get: function (id, callback, errCallback) {
                        Request.get({
                            url: ApiURLs.fleets.waypoints + id,
                            successCallback: callback,
                            errorCallback: errCallback
                        });
                    },
                    create: function (payload, callback, errCallback) {
                        Request.post({
                            url: ApiURLs.fleets.waypoints,
                            method: 'POST',
                            successCallback: callback,
                            errorCallback: errCallback
                        }, payload);
                    },
                    update: function (id, payload, callback, errCallback) {
                        Request.post({
                            url: ApiURLs.fleets.waypoints + id,
                            method: 'PUT',
                            successCallback: callback,
                            errorCallback: errCallback
                        }, payload);
                    }
                },
                Chat: {
                    jobs: function (callback, errorCallback, filters) {
                        Request.get({
                            url: ApiURLs.fleets.chatJobs,
                            successCallback: callback,
                            errorCallback: errorCallback,
                            data: filters
                        });
                    },
                    chatHistory: function (id, callback, errCallback, filters) {
                        Request.get({
                            url: ApiURLs.fleets.chatHistory.replace(':jobId', id),
                            successCallback: callback,
                            errorCallback: errCallback,
                            data: filters
                        });
                    },
                    sendMessage: function (id, message, callback, errCallback) {
                        Request.post({
                            url: ApiURLs.fleets.sendMessage.replace(':jobId', id),
                            method: 'POST',
                            successCallback: callback,
                            errorCallback: errCallback
                        }, angular.extend({
                            message: message
                        }));
                    }
                },
                RoutePlanning: {
                    getRoutePlanningAvailableJobs: function (callback, errCallback, filters) {
                        Request.get({
                            url: ApiURLs.jobs.getRoutePlanningAvailableJobs,
                            successCallback: callback,
                            errorCallback: errCallback,
                            data: filters
                        });
                    },
                    getAllRuns: function(callback, errorCallback, data) {
                        Request.get({
                            url: ApiURLs.jobs.routePlanning,
                            successCallback: callback,
                            errorCallback: errorCallback,
                            data
                        });
                    },
                    getRunDetails: function(callback, errorCallback, id) {
                        Request.get({
                            url: `${ApiURLs.jobs.routePlanning}/${id}`,
                            successCallback: callback,
                            errorCallback: errorCallback
                        });
                    },
                    saveRun: function (callback, errorCallback, payload) {
                        Request.post({
                            method: 'POST',
                            url: ApiURLs.jobs.routePlanning,
                            successCallback: callback,
                            errorCallback: errorCallback
                        }, payload);
                    }
                }
            };
        });
})();



// WEBPACK FOOTER //
// ./js/services/FleetService.js